import React from "react";
import PropTypes from "prop-types";
import { Small_Business_Loan } from "../../../utils/Keywords";
import Layout from "../../../layout/Layout";
import ProductDetails from "../../../templates/ProductDetails";

const SmallBusinessLoan = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Small Business Loan"}>
      <ProductDetails keyword={Small_Business_Loan} />
    </Layout>
  );
};

SmallBusinessLoan.propTypes = {
  pageContext: PropTypes.object,
};

export default SmallBusinessLoan;
